module.exports = __webpack_public_path__ + "img/icon_house.f7290c90.svg";